module.exports = __webpack_public_path__ + "img/5-1.46b85775.jpg";